module.exports = __webpack_public_path__ + "static/img/item3.e0b6ee2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/web/item3.png
// module id = umJ1
// module chunks = 1